import React, { useRef, useEffect, useCallback } from "react";
import { Box, Container, Typography } from "@mui/material";
import { COLORS, FONT } from "../../constants";
import useSystemHook from "../../hooks/SystemHook";

const SPEED = 1.0; // px per frame at 60fps

const WholesaleCustomers = ({ customers }) => {
  const { isMobile } = useSystemHook();
  const trackRef = useRef(null);
  const posRef = useRef(0);
  const rafRef = useRef(null);
  const pausedRef = useRef(false);

  const animate = useCallback(() => {
    if (!pausedRef.current && trackRef.current) {
      posRef.current -= SPEED;
      const halfWidth = trackRef.current.scrollWidth / 2;
      if (-posRef.current >= halfWidth) posRef.current = 0;
      trackRef.current.style.transform = `translateX(${posRef.current}px)`;
    }
    rafRef.current = requestAnimationFrame(animate);
  }, []);

  useEffect(() => {
    rafRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(rafRef.current);
  }, [animate]);

  return (
    <Box sx={{ backgroundColor: COLORS.background, py: isMobile ? 6 : 8 }}>
      <Container maxWidth="lg">
        <Typography
          variant="h5"
          sx={{ fontWeight: 700, textAlign: "center", mb: 1, color: COLORS.themeBlack }}
        >
          Trusted By South Africa's Leading Businesses
        </Typography>
        <Typography
          sx={{ textAlign: "center", color: COLORS.lightText, mb: 6, fontSize: isMobile ? FONT.size.xs : FONT.size.md }}
        >
          Apply for a wholesale account and join a growing network of retailers, workshops, and
          resellers that rely on Argus.
        </Typography>
      </Container>

      <Box sx={{ overflow: "hidden", position: "relative" }}>
        <Box
          ref={trackRef}
          onMouseEnter={() => { pausedRef.current = true; }}
          onMouseLeave={() => { pausedRef.current = false; }}
          sx={{ display: "flex", width: "max-content" }}
        >
          {[...customers, ...customers].map((customer, index) => (
            <Box
              key={index}
              sx={{
                px: 5,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Box
                component="img"
                src={customer.image}
                alt={customer.name}
                sx={{
                  height: 80,
                  maxWidth: 200,
                  objectFit: "contain",
                  opacity: 0.85,
                  transition: "opacity 0.3s",
                  "&:hover": { opacity: 1 },
                }}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default WholesaleCustomers;
